var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9306 14.884C28.9306 21.4165 24.1882 27.5348 17.7091 29.3249C17.2683 29.4452 16.7873 29.4452 16.3465 29.3249C9.8674 27.5348 5.125 21.4165 5.125 14.884V9.01939C5.125 7.92396 5.95327 6.68158 6.98191 6.26746L14.4228 3.22167C16.0926 2.54037 17.9763 2.54037 19.6461 3.22167L27.087 6.26746C28.1023 6.68158 28.9439 7.92396 28.9439 9.01939L28.9306 14.884Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.8451C18.6567 16.8451 19.9999 15.5019 19.9999 13.8451C19.9999 12.1882 18.6567 10.8451 16.9999 10.8451C15.343 10.8451 13.9999 12.1882 13.9999 13.8451C13.9999 15.5019 15.343 16.8451 16.9999 16.8451Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 16.8451L16.9999 21.8451",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafe);
export default __webpack_public_path__ + "static/media/security-safe.6f4f773d.svg";
export { ForwardRef as ReactComponent };